// https://www.tutorialpedia.org/blog/how-to-round-to-at-most-2-decimal-places-if-necessary/#method-3-custom-function-for-edge-cases
export function roundToAtMost2Decimals(num) {
    const rounded = Math.round((num + Number.EPSILON) * 100) / 100;
    // Convert to string and trim trailing zeros/decimal if needed
    return rounded % 1 === 0 ? rounded : rounded;
}

export function roundToAtMostNDecimals(num, n) {
    const roundingFactor = Math.pow(10, n);
    const rounded =
        Math.round((num + Number.EPSILON) * roundingFactor) / roundingFactor;

    return rounded % 1 === 0 ? rounded : rounded;
}

export const toNumberSafe = (value) => (isNaN(value) ? 0 : Number(value));
